import * as React from "react";
import type { SVGProps } from "react";
const SvgAlertTriangleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 2000 2000"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M881.42 114.185a241.67 241.67 0 0 1 237.12 0 241.8 241.8 0 0 1 88.07 85.25l.21.356 705.83 1178.339.61 1.03a241.7 241.7 0 0 1 32.39 120.17c.12 42.2-10.82 83.69-31.71 120.35a241.7 241.7 0 0 1-87.4 88.61 241.64 241.64 0 0 1-119.9 33.37l-.83.01H293.323a241.74 241.74 0 0 1-119.902-33.38 241.666 241.666 0 0 1-86.723-329.13l.61-1.03L793.354 199.434a241.67 241.67 0 0 1 88.065-85.249m118.561 118.919a91.67 91.67 0 0 0-78.375 44.125L216.341 1454.62a91.65 91.65 0 0 0 0 90.78 91.6 91.6 0 0 0 33.151 33.61 91.7 91.7 0 0 0 45.134 12.66H1705.34c15.88-.24 31.43-4.6 45.13-12.66a91.64 91.64 0 0 0 33.15-33.61 91.65 91.65 0 0 0 12.03-45.65 91.76 91.76 0 0 0-12.03-45.14L1078.36 277.229c-.03-.05-.07-.101-.1-.151a91.6 91.6 0 0 0-33.31-32.185 91.65 91.65 0 0 0-44.969-11.789m0 358.562c41.419 0 74.999 33.578 74.999 75v333.333c0 41.421-33.58 75.001-74.999 75.001-41.422 0-75-33.58-75-75.001V666.666c0-41.422 33.578-75 75-75m-75 741.664c0-41.42 33.578-75 75-75h.829c41.43 0 75 33.58 75 75s-33.57 75-75 75h-.829c-41.422 0-75-33.58-75-75"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAlertTriangleIcon;
